// stores/cookieStore.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCookieStore = defineStore('cookieStore', () => {
  const consentGiven = ref(false);
  const setConsent = (value: boolean) => {
    consentGiven.value = value;
  };
  return { consentGiven, setConsent }
});